import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import CsfMemberActivitiesDataLayer from "../csf-membre-activities/CsfMemberActivitiesDataLayer";
import {startLoadingSpinner, stopLoadingSpinner} from "../../csf-ufc-pivotal/includes/utils";
import CsfMembreUtils from "./CsfMembreUtils";
import PivotalApiEnvironments
  from "../../../js/csf/pivotal/PivotalApiEnvironments";

class CsfMemberDataLayer {

  static MEMBER_SEARCH_KEY = 'Current_Ux_Client_User';
  static MEMBER_SEARCH_LIST_KEY = 'CSF_EM_Ux_Log_Contact_SRL';
  static MEMBER_UFC_CASE_FORM = 'CSF_EM_Contact_Info';
  static MEMBER_UFC_HISTORY_INFO_FORM = 'CSF_EM_UFC_History_Info';

  constructor(apiUrl, apiEnv, accessToken) {
    this.accessToken = accessToken;
    this.apiUrl = apiUrl;
    this.apiEnv = apiEnv;
    this.isInit = true;
  }
  getMember (setMemberCallback) {
    const requestData = {
      search: CsfMemberDataLayer.MEMBER_SEARCH_KEY,
      searchResultsList: CsfMemberDataLayer.MEMBER_SEARCH_LIST_KEY,
    };
    const pivotalSearchApi = new PivotalSearchApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          const memberInfo = response.payload.data.rows[0];
          setMemberCallback(memberInfo);
        } else {
          console.log("Error fetching MemberInfo");
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  static fetchAccessToken(setAccessTokenCallback) {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest(PivotalApiEnvironments.getLoginSuffix())
      .then(response => {
        if (response?.api_access_token) {
          setAccessTokenCallback(response.api_access_token);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  getMemberUFCCase(contactId, setUfcCaseCallback) {
    const requestData = {
      form: CsfMemberDataLayer.MEMBER_UFC_CASE_FORM,
      recordId: contactId
    };
    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success && response?.payload?.data?.primary) {
            setUfcCaseCallback(response.payload.data.primary);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  getUfcHistoryInfo(EM_Education_File_Id, setUfcHistoryCallback) {
    if (EM_Education_File_Id === null) {
      console.error('EM_Education_File_Id is null');
      return;
    }

    const requestData = {
      form: CsfMemberDataLayer.MEMBER_UFC_HISTORY_INFO_FORM,
      recordId: EM_Education_File_Id
    };
    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success && response?.payload?.data?.primary) {
          // La période courante et précédente sont affichées via ce end point.
          // Les périodes sont en ordre chronologique, le plus petit nombre est par conséquent la période précédente.
          setUfcHistoryCallback(response?.payload?.data?.primary?.Periode__Secondary);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  getCurrentPeriodHistoryInfo(ufcHistory) {
    // La période courante et précédente sont affichées via le end point CSF_EM_UFC_History_Info.
    // Les périodes sont en ordre chronologique, le plus petit nombre est par conséquent la période précédente.
    if (ufcHistory.length > 1) {

      return !CsfMembreUtils.objectIsEmpty(ufcHistory[1]) ? ufcHistory[1] : {};
    }

    return {};
  }

  getPreviousPeriodHistoryInfo(ufcHistory) {
    // La période courante et précédente sont affichées via le end point CSF_EM_UFC_History_Info.
    // Les périodes sont en ordre chronologique, le plus petit nombre est par conséquent la période précédente.
    if (ufcHistory.length > 0) {
      return !CsfMembreUtils.objectIsEmpty(ufcHistory[0]) ? ufcHistory[0] : {};
    }

    return {};
  }

  getUfcPeriodSubtitle(ufcHistory, currentPeriod = true) {
    stopLoadingSpinner();

    if (currentPeriod) {
      return !CsfMembreUtils.objectIsEmpty(ufcHistory[1]) ? this.#getPeriodSubtitle(ufcHistory[1]): "";
    }

    return !CsfMembreUtils.objectIsEmpty(ufcHistory[0]) ? this.#getPeriodSubtitle(ufcHistory[0]): "";
  }

  #getPeriodSubtitle(period) {
    const langCode = (document?.documentElement?.lang === 'fr'?'fr-FR':'en-US');
    return this.#ufcPeriodDateFormat(period?.Start_Date, langCode) + ' - ' + this.#ufcPeriodDateFormat(period?.End_Date, langCode);
  }

  #ufcPeriodDateFormat(dateString, langCode) {
    // langCode: 'fr-FR' , 'en-US'

    if (dateString == null || dateString === '') {
      return '';
    }

    const date = new Date(dateString);

    const options = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    };

    return new Intl.DateTimeFormat(langCode, options).format(date);
  }
}

export default CsfMemberDataLayer;
